"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PromoContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Dashboard = _interopRequireDefault(require("@material-ui/icons/Dashboard"));
var _excluded = ["style", "children"];
var _default = exports["default"] = function _default(_ref) {
  var title = _ref.title,
    description = _ref.description;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-hidden m-2 p-10 bg-primary text-white text-center rounded-lg",
    style: {
      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 30px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-24"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-2xl flex items-center justify-center mb-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-primary bg-white rounded-full flex items-center p-4"
  }, /*#__PURE__*/_react["default"].createElement(_Dashboard["default"], {
    fontSize: "inherit"
  }))), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-4xl font-bold py-1 truncate"
  }, title || t('feedView.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm opacity-75"
  }, description || t('feedView.description'))));
};
var PromoContainer = exports.PromoContainer = function PromoContainer(_ref2) {
  var style = _ref2.style,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var width = style.width;
  if (width < 0) return null;else return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    style: {
      maxWidth: width
    }
  }), children);
};
//# sourceMappingURL=PromoItem.js.map